import { Directive, Input } from '@angular/core';

import { ApiOperationPath } from '../services/api-catalog.service';

/**
 * Declara, una sola vez por formulario, contra que operacion de la API se envian sus datos. Los campos que cuelgan
 * de ella la obtienen por inyeccion de dependencias de elemento y componen solos la ruta de su valor dentro del
 * payload, de modo que no hay que anotar campo a campo ni tocar el TS del componente.
 *
 * <form [formGroup]="form" [appApiContext]="'/records/{recordId}/actors/{actorId}'"
 *       [apiPathParams]="{recordId: recordId, actorId: actorId}">
 *   <app-input [control]="form.get('notes')" ...></app-input>
 * </form>
 *
 * La operacion se identifica con el path tal como lo publica el back en GET /api-reference; el metodo se deduce del
 * catalogo (ver ApiCatalogService), asi que no hay registro de endpoints en el front. Si el back no la publica (no
 * existe o no es publica), el helper no se muestra.
 *
 * apiBodyRoot es la clave bajo la que el formulario envuelve sus valores dentro del cuerpo, cuando los FormControl
 * no coinciden 1:1 con las claves del payload (p.ej. transport-goods envia {transportData: {...valores}}).
 *
 * Los valores de apiPathParams solo sirven para mostrar la URL concreta del recurso que se esta editando; si no se
 * pasan, el helper muestra el path con los parametros entre llaves.
 */
@Directive({
  selector: '[appApiContext]',
})
export class ApiContextDirective {
  @Input('appApiContext') operationPath: ApiOperationPath | null = null;
  @Input() apiBodyRoot: string | null = null;
  @Input() apiPathParams: Record<string, string | undefined> | null = null;
}
